import './introbar.less'

import {View, classes, m} from '@codeurs/front'

import Container from 'views/layout/container'
import {scrollbarWidth} from 'util/scrollbar'

class Pull extends View<{
	direction: 'left' | 'right'
	width?: string
	[key: string]: any
}> {
	render = this.render

	view() {
		const {children, channel, direction, width = '100%', ...attrs} = this.attrs
		const scrollBarWidth = `${scrollbarWidth()}px`
		const margin = `margin-${direction}`
		return m('.pull',
			{
				...attrs,
				style: {
					[margin]: `calc((100vw + ${scrollBarWidth} - 100%) / -2 - 1.5px)`,
					width: `calc(${width} + (100vw - ${scrollBarWidth} - 100%) / 2)`
				}
			},
			children
		)
	}
}

export default class IntroBar extends View<{
	channel: string
}> {
	render = this.render

	view() {
		const {channel} = this.attrs
		return m('.introbar',
			classes({mod: channel}),
			m(Container,
				{class: channel == 'article' ? 'mod-article' : null},
				m(Pull, {
					class: 'introbar-bg',
					direction: 'left',
					width: '100% - 12.5rem'
				}),
				m(Pull, {
					class: 'introbar-lines',
					direction: 'left',
					width: '0px',
					mod: channel
				}),
				m('.introbar-content', classes({mod: channel}), this.children)
			)
		)
	}
}
